import styled from 'styled-components';
import Avatar from '../../Avatar';
import { IBriefUserInfoFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import ThreadIndicatorCounter from './ThreadIndicatorCounter';

interface IProps {
  participants: IBriefUserInfoFieldsFragment[];
}

const Container = styled.div`
  display: inline-flex;

  > :not(:first-child) {
    margin-left: -8px;
  }
`;

const ThreadIndicatorAvatars = ({ participants }: IProps) => {
  if (participants.length <= 2) {
    return (
      <Container>
        {participants.map((participant) => (
          <Avatar
            key={participant.id}
            picture={participant.picture}
            size={16}
          />
        ))}
      </Container>
    );
  }

  const firstParticipant = participants[0];
  const otherParticipants = participants.slice(1).length;

  return (
    <Container>
      <Avatar picture={firstParticipant.picture} size={16} />
      <ThreadIndicatorCounter amount={otherParticipants} />
    </Container>
  );
};

export default ThreadIndicatorAvatars;
